import * as endpoints from "../data/links/endpoints";
import { replaceEmojisWithUnicode } from "../helpers/functions";
import { api } from "./api";

export async function generateWorkout(data) {
  let { typeId, categoryId } = data;
  let body = {
    type_id: typeId,
    category_id: categoryId,
  };
  return api.post(endpoints.GENERATE_WOD, body).then((res) => res);
}

export async function getWorkoutById({ signal, wodId }) {
  if (wodId === 0) return;
  return api
    .get(endpoints.GET_WOD + wodId, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}

export async function getUsersWorkouts(data) {
  let { typeId, categoryId, levelId, limit } = data;
  let body = new FormData();
  body.append("level", levelId);
  body.append("limit", limit);

  if (typeId !== -1) {
    body.append("type_id", typeId);
  }

  if (categoryId !== -1) {
    body.append("category_id", categoryId);
  }

  return api.post(endpoints.GET_USERS_WODS, body).then((res) => res);
}

export async function getPublicWorkouts(data) {
  let { typeId, categoryId, limit } = data;
  let body = new FormData();
  body.append("limit", limit);

  if (typeId !== -1) {
    body.append("type_id", typeId);
  }

  if (categoryId !== -1) {
    body.append("category_id", categoryId);
  }
  return api.post(endpoints.GET_PUBLIC_WODS, body).then((res) => res);
}

export async function getWorkoutComments({ signal, workoutId }) {
  return api
    .get(endpoints.GET_WODS_COMMENTS + workoutId, { signal })
    .then((res) => res.data.comments)
    .catch((error) => error.response);
}

export async function getWorkoutScores({ wodId, signal }) {
  return api
    .get(endpoints.GET_WORKOUTS_SCORE + wodId, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}

export async function getWorkoutLeaderboard({ workoutId, gender, signal }) {
  if (workoutId === 0) return;

  return api
    .get(endpoints.GET_WORKOUT_LEADERBOARD + "/" + workoutId + "/" + gender, {
      signal,
    })
    .then((res) => res.data.leaderboard);
}

export async function deleteWod({ wodId }) {
  let body = {
    id: wodId,
  };
  return api.post(endpoints.DELETE_WOD, body).then((res) => res);
}

export async function shareWorkout({ wodId }) {
  let body = {
    id: wodId,
  };
  return api.post(endpoints.SHARE_WORKOUT, body).then((res) => res);
}

export async function saveWorkout(data) {
  let {
    workoutTypeId,
    timecap,
    female_timecap,
    structureId,
    wodExercises,
    every,
    rounds,
    rest,
    categoryId,
    projectedScore,
    femaleProjectedScore,
    created,
  } = data;

  let body = new FormData();
  body.append("type_id", workoutTypeId);
  body.append("timecap", timecap);
  body.append("female_timecap", female_timecap || timecap);
  body.append("structure_id", structureId);
  body.append("exercises", JSON.stringify(wodExercises));
  body.append("every", every || 0);
  body.append("rounds", rounds || 0);
  body.append("rest", rest || 0);
  body.append("created_by", created);
  body.append("projected_score", projectedScore || 0);
  body.append("female_projected_score", femaleProjectedScore || 0);

  if (created === 1) {
    let category = wodExercises[0].category_id;
    let sameCategories = wodExercises.every(
      (item) => item.category_id === category,
    );
    if (sameCategories) {
      body.append("category_id", category);
    } else {
      body.append("category_id", 1);
    }
  } else {
    body.append("category_id", categoryId);
  }

  return api.post(endpoints.SAVE_WOD, body).then((res) => res);
}

export async function postComment(data) {
  let { workoutId, comment } = data;
  let body = {
    comment: replaceEmojisWithUnicode(comment),
    wod_id: workoutId,
  };

  return api.post(endpoints.POST_COMMENT, body).then((res) => res);
}

export async function postScore(data) {
  let { wodId, score, details, result, fileId } = data;

  let body = {
    wod_id: wodId,
    score,
    result,
    details: JSON.stringify(details),
    file_id: fileId,
  };

  return api.post(endpoints.SET_WOD_SCORE, body).then((res) => res);
}

export async function getWorkoutStats({ workoutId, signal }) {
  return api
    .get(endpoints.GET_WORKOUT_STATS + workoutId, { signal })
    .then((res) => res.data);
}

export async function getUsersPbWorkoutScore(data) {
  let { wodId, type_id } = data;
  let body = {
    wod_id: wodId,
    type_id,
  };

  return api.post(endpoints.GET_USERS_WORKOUT_PB, body).then((res) => res);
}

export async function likeWorkout(data) {
  return api.post(endpoints.LIKE_WORKOUT, data).then((res) => res);
}

// export async function hasUserLikedWorkout({ workoutId, signal }) {
//   return api
//     .get(endpoints.HAS_USER_LIKED_WORKOUT + workoutId, { signal })
//     .then((res) => res.data)
//     .catch((error) => error.response);
// }

export async function getWorkoutPerformanceStats({ wodId, signal }) {
  return api
    .get(endpoints.GET_WORKOUT_PERFORMANCE_STATS + wodId, { signal: signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}

export async function getEmomDetails({ workoutId, signal }) {
  return api
    .get(endpoints.GET_EMOM_DETAILS + workoutId, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}

export async function getScoreRange({ workoutId, signal }) {
  return api
    .get(endpoints.GET_SCORE_RANGE + workoutId, { signal })
    .then((res) => res.data.score_range)
    .catch((error) => error.response);
}

export async function getWeeklyWorkout({ level, signal }) {
  return api
    .get(endpoints.GET_WEEKLY_WORKOUT + level, { signal })
    .then((res) => res.data)
    .catch((error) => error.response);
}

export async function getMostPerformedWorkout({ signal }) {
  return api
    .get(endpoints.GET_MOST_PERFORMED_WORKOUT, { signal })
    .then((res) => res.data.wod_id)
    .catch((error) => error.response);
}

export async function getWorkoutPerformanceStatistics({
  type,
  dateRange,
  signal,
}) {
  return api
    .get(
      endpoints.GET_WORKOUT_PERFORMANCE_STATISTICS + type + "/" + dateRange,
      { signal },
    )
    .then((res) => res.data.stats)
    .catch((error) => error.response);
}

export async function usersWorkoutAccess({ wodId, signal }) {
  return api
    .get(endpoints.HAS_USER_ACCESS_TO_WORKOUT + wodId, { signal })
    .then((res) => res.data.exists)
    .catch((error) => error.response);
}
